import api from '../api/axios';

const getAll = (options = {}) => {
  const { makeId, typeId, query, skip = 0, take = 25, sortBy, sortOrder } = options;
  const params = [];
  if (makeId) params.push(`makeId=${makeId}`);
  if (typeId) params.push(`typeId=${typeId}`);
  if (query) params.push(`query=${encodeURIComponent(query)}`);
  if (sortBy) params.push(`sortBy=${sortBy}`);
  if (sortOrder) params.push(`sortOrder=${sortOrder}`);
  params.push(`skip=${skip}`);
  params.push(`take=${take}`);
  const queryString = params.length ? '?' + params.join('&') : '';
  return api.get(`/equipment-models${queryString}`);
};

const getByMake = (makeId) => {
  return api.get(`/equipment-models/by-make/${makeId}`);
};

const getById = (id) => {
  return api.get(`/equipment-models/${id}`);
};

const create = (item) => {
  return api.post('/equipment-models', item);
};

const update = (id, item) => {
  return api.put(`/equipment-models/${id}`, item);
};

const remove = (id) => {
  return api.delete(`/equipment-models/${id}`);
};

const restore = (id) => {
  return api.get(`/equipment-models/${id}/restore`);
};

const batchDelete = (ids) => {
  return api.post('/equipment-models/batch-delete', { ids });
};

const importCSV = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/equipment-models/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const equipmentModelsServices = {
  getAll,
  getByMake,
  getById,
  create,
  update,
  remove,
  restore,
  batchDelete,
  importCSV,
};

export default equipmentModelsServices;
